var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMoustache = function SvgMoustache(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 44,
    height: 34,
    viewBox: "0 0 2.23 1.7",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".str0{stroke:#000;stroke-width:.25;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256}.fil0{fill:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2315934241040"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M1.32.16C.8 0 .47.41.66.94c.09.26.22.5.4.61.19.12.69-.28.69-.64 0-.38-.09-.65-.43-.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M1.37.93c.21.04.26.25.49.25.19 0 .28-.15.24-.31M.98.92c-.19 0-.16.06-.29.14-.1.08-.24.11-.36.08-.1-.03-.2-.16-.2-.28"
  })))));
};

export default SvgMoustache;